module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impact-page"
  }, [_c('impact-header', {
    attrs: {
      "title": "学生影响明细",
      "tags": ['异动 + 请假 / 旷课汇总到学生', '运营跟进名单'],
      "chips": _vm.chips,
      "loaded-at": _vm.loadedAt
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "section-filters"
  }, [_c('filter-pills', {
    attrs: {
      "options": _vm.dayOptions,
      "label": "时间窗口"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.days),
      callback: function($$v) {
        _vm.days = $$v
      },
      expression: "days"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.countOptions,
      "label": "受影响"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.minCount),
      callback: function($$v) {
        _vm.minCount = $$v
      },
      expression: "minCount"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.remainOptions,
      "label": "未消课时"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.minRemain),
      callback: function($$v) {
        _vm.minRemain = $$v
      },
      expression: "minRemain"
    }
  }), _vm._v(" "), _c('filter-pills', {
    attrs: {
      "options": _vm.statusOptions,
      "label": "状态"
    },
    on: {
      "on-change": _vm.reload
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "kpi-grid"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.kpiCards), function(card) {
    return _c('kpi-card', _vm._b({
      key: card.key
    }, 'kpi-card', card, false))
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dash-section"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.loading) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("学生清单"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v(_vm._s(_vm.listSub))])]), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    class: {
      'is-disabled': _vm.exporting
    },
    on: {
      "click": _vm.doExport
    }
  }, [_vm._v(_vm._s(_vm.exporting ? '导出中…' : '导出待跟进名单 →'))])]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "impact-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("学生")]), _vm._v(" "), _c('th', [_vm._v("班主任")]), _vm._v(" "), _c('th', [_vm._v("主老师")]), _vm._v(" "), _c('th', [_vm._v("影响来源明细")]), _vm._v(" "), _c('th', {
    staticClass: "num sortable",
    class: {
      'is-active': _vm.sortKey === 'cnt'
    },
    on: {
      "click": function($event) {
        return _vm.toggleSort('cnt')
      }
    }
  }, [_vm._v("\n                受影响次数 "), _c('span', {
    staticClass: "sort-ind"
  }, [_vm._v(_vm._s(_vm.sortInd('cnt')))])]), _vm._v(" "), _c('th', {
    staticClass: "num sortable",
    class: {
      'is-active': _vm.sortKey === 'lost'
    },
    on: {
      "click": function($event) {
        return _vm.toggleSort('lost')
      }
    }
  }, [_vm._v("\n                损失课次 "), _c('span', {
    staticClass: "sort-ind"
  }, [_vm._v(_vm._s(_vm.sortInd('lost')))])]), _vm._v(" "), _c('th', {
    staticClass: "num"
  }, [_vm._v("剩余课时")]), _vm._v(" "), _c('th', [_vm._v("最近受影响")]), _vm._v(" "), _c('th', [_vm._v("当前状态")]), _vm._v(" "), _c('th', [_vm._v("风险")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.list), function(row) {
    return _c('tr', {
      key: row.uid
    }, [_c('td', [_c('span', {
      staticClass: "t-name"
    }, [_vm._v(_vm._s(row.userName || '—'))]), _c('span', {
      staticClass: "t-id"
    }, [_vm._v(_vm._s(row.uid))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.adviserName || '—'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.tchName || '—'))]), _vm._v(" "), _c('td', {
      staticClass: "wrap"
    }, [_vm._l(((row.sources || [])), function(s) {
      return _c('span', {
        key: s.type,
        staticClass: "mini-badge",
        style: (_vm.sourceStyle(s.type))
      }, [_vm._v(_vm._s(_vm.typeLabel(s.type)) + "×" + _vm._s(s.count))])
    }), _vm._v(" "), (!(row.sources || []).length) ? _c('span', {
      staticClass: "t-muted"
    }, [_vm._v("—")]) : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', [_vm._v(_vm._s(_vm.fmtNum(row.impactCount)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_c('b', {
      class: {
        't-danger': _vm.num(row.lostLessons) >= 10
      }
    }, [_vm._v(_vm._s(_vm.fmtNum(row.lostLessons)))])]), _vm._v(" "), _c('td', {
      staticClass: "num"
    }, [_vm._v(_vm._s(_vm.fmtNum(row.remainHours)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.lastImpactDate || '—'))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.statusBadge(row.status)
    }, [_vm._v(_vm._s(row.status || '—'))])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "badge",
      class: _vm.levelBadge(row.risk)
    }, [_vm._v(_vm._s(row.risk || '—'))])])])
  }), _vm._v(" "), (!_vm.list.length) ? _c('tr', [_c('td', {
    staticClass: "empty",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("当前筛选条件下没有学生")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('Page', {
    attrs: {
      "total": _vm.num(_vm.d.total),
      "current": _vm.pageIndex,
      "page-size": _vm.pageSize,
      "page-size-opts": [20, 50, 100],
      "show-total": "",
      "show-sizer": "",
      "size": "small"
    },
    on: {
      "on-change": _vm.onPageChange,
      "on-page-size-change": _vm.onPageSizeChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "grid g2"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), (!_vm.scatterList.length) ? _c('div', {
    staticClass: "chart-empty"
  }, [_vm._v("暂无数据")]) : _c('svg', {
    staticClass: "svg-chart",
    attrs: {
      "viewBox": '0 0 ' + _vm.sc.W + ' ' + _vm.sc.H
    }
  }, [_c('rect', {
    attrs: {
      "x": _vm.sc.zoneX,
      "y": _vm.sc.PT,
      "width": _vm.sc.zoneW,
      "height": _vm.sc.zoneH,
      "fill": "#E6464E",
      "fill-opacity": "0.05",
      "rx": "4"
    }
  }), _vm._v(" "), _vm._l((_vm.sc.yTicks), function(g) {
    return _c('g', {
      key: 'y' + g.v
    }, [_c('line', {
      staticClass: "gridline",
      attrs: {
        "x1": _vm.sc.PL,
        "y1": g.y,
        "x2": _vm.sc.W - _vm.sc.PR,
        "y2": g.y
      }
    }), _vm._v(" "), _c('text', {
      staticClass: "axis-l",
      attrs: {
        "x": _vm.sc.PL - 8,
        "y": g.y + 3,
        "text-anchor": "end"
      }
    }, [_vm._v(_vm._s(g.v))])])
  }), _vm._v(" "), _vm._l((_vm.sc.xTicks), function(g) {
    return _c('text', {
      key: 'x' + g.v,
      staticClass: "axis-l",
      attrs: {
        "x": g.x,
        "y": _vm.sc.H - _vm.sc.PB + 16,
        "text-anchor": "middle"
      }
    }, [_vm._v(_vm._s(g.v))])
  }), _vm._v(" "), _vm._l((_vm.sc.points), function(p) {
    return _c('circle', {
      key: p.uid,
      attrs: {
        "cx": p.x,
        "cy": p.y,
        "r": p.danger ? 4.6 : 3.4,
        "fill": p.danger ? '#E6464E' : '#5C78A8',
        "fill-opacity": p.danger ? 0.75 : 0.45,
        "stroke": p.danger ? '#E6464E' : '#5C78A8',
        "stroke-width": "1.1"
      }
    }, [_c('title', [_vm._v(_vm._s(p.title))])])
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": _vm.sc.PL,
      "y1": _vm.sc.H - _vm.sc.PB,
      "x2": _vm.sc.W - _vm.sc.PR,
      "y2": _vm.sc.H - _vm.sc.PB,
      "stroke": "#DFE4EE"
    }
  }), _vm._v(" "), _c('text', {
    staticClass: "axis-t",
    attrs: {
      "x": (_vm.sc.W + _vm.sc.PL) / 2,
      "y": _vm.sc.H - 2,
      "text-anchor": "middle"
    }
  }, [_vm._v("损失课次")]), _vm._v(" "), _c('text', {
    staticClass: "axis-t",
    attrs: {
      "transform": 'translate(12,' + (_vm.sc.H - _vm.sc.PB + _vm.sc.PT) / 2 + ') rotate(-90)',
      "text-anchor": "middle"
    }
  }, [_vm._v("剩余课时")])], 2), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_vm._v("\n          右上区 = 损失课次 ≥ 高频学生人均（" + _vm._s(_vm.fmtNum(_vm.sc.lostLine)) + "）且剩余课时 ≥ " + _vm._s(_vm.sc.remainLine) + "，共 "), _c('b', [_vm._v(_vm._s(_vm.sc.dangerCount))]), _vm._v(" 人。剩余课时高但损失也高，说明「钱还在、人快走了」，优先用补课 + 固定新老师处理。\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("影响来源构成"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("高频受影响学生 · " + _vm._s(_vm.fmtNum(_vm.d.highFreqCount)) + " 人")])])]), _vm._v(" "), _c('bar-list', {
    attrs: {
      "rows": _vm.sourceRows,
      "unit": "次",
      "right-width": 110
    }
  }), _vm._v(" "), _c('dl', {
    staticClass: "kv"
  }, [_c('dt', [_vm._v("事件总数")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.sourceTotal)) + " 次")]), _vm._v(" "), _c('dt', [_vm._v("异动类（离职 / 淘汰 / 关闭时间）")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.changeEventCount)) + " 次")]), _vm._v(" "), _c('dt', [_vm._v("请假类（3h内 / 请假 / 旷课）")]), _c('dd', [_vm._v(_vm._s(_vm.fmtNum(_vm.d.leaveEventCount)) + " 次")]), _vm._v(" "), _c('dt', [_vm._v("请假为主的高频学生")]), _c('dd', [_vm._v(_vm._s(_vm.fmtRate(_vm.d.leaveDominantRate)))])]), _vm._v(" "), (_vm.num(_vm.d.highFreqCount) > 0) ? _c('div', {
    staticClass: "note is-warning"
  }, [_c('b', [_vm._v("近 " + _vm._s(_vm.days) + " 天 " + _vm._s(_vm.fmtNum(_vm.d.highFreqCount)) + " 名高频受影响学生中，" + _vm._s(_vm.fmtRate(_vm.d.leaveDominantRate)) + " 以请假类事件为主。")]), _vm._v("重复请假对同一学生的伤害比一次性离职更隐蔽，建议降低与高频请假老师的排课绑定度。\n        ")]) : _vm._e()], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("核心指标")]), _vm._v(" "), _c('span', {
    staticClass: "section-legend"
  }, [_c('i', {
    staticClass: "legend-dot is-danger"
  }), _vm._v("红=预警\n        / "), _c('i', {
    staticClass: "legend-dot is-warning"
  }), _vm._v("黄=关注\n        / "), _c('i', {
    staticClass: "legend-dot is-healthy"
  }), _vm._v("绿=健康\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-head"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("学生影响清单")]), _vm._v(" "), _c('span', {
    staticClass: "section-right"
  }, [_vm._v("谁该打电话、谁该补课时、谁已经快走了")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('span', {
    staticClass: "card-title"
  }, [_vm._v("损失课次 vs 剩余课时"), _c('span', {
    staticClass: "card-sub"
  }, [_vm._v("点 = 高频受影响学生，右上需立刻跟进")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ba4824e2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tchImpact/TchImpactStudent.vue
// module id = 1939
// module chunks = 8